/* Built In Imports */
import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import { useEOEContext } from '@store/EOEContext';

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const RegisterStickyButton = ({ sectionContent, region, lang }) => {
  const pathName = usePathname();
  const [isVisible, setIsVisible] = useState(false);
  // const topbannerDiv = document.getElementById('top-banner');
  const registerDiv =
    document.getElementById('program-details-eoe') ||
    document.getElementById('program-details-eoe-toronto') || document.getElementById('program-details-eoe-philly') || document.getElementById('program-details-eoe-san-francisco');
  const footerDiv = document.getElementById('footer');
  const { isIeDone, city, ieLang, cityName } = useEOEContext();

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const heightToHideFrom = window.innerHeight * 1.3;

    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    // console.log('winScroll > heightToHideFrom', winScroll > heightToHideFrom);

    const rect = registerDiv?.getBoundingClientRect();
    const footerRect = footerDiv?.getBoundingClientRect();

    let vis = false;
    // console.log('inViewPort', footerRect);
    if (winScroll > heightToHideFrom) {
      vis = false;
      if (rect?.top > 0 || Math.abs(rect?.top) > rect?.height) {
        vis = true;
      } else {
        vis = false;
      }
      if (footerRect?.top < 0) {
        vis = false;
      }
    } else {
      vis = false;
    }
    setIsVisible(vis);
  };

  const registerClick = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'EoE_Interested',
      });

      // window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'view_item',
      //   ecommerce: {
      //     currency: '',
      //     value: '',
      //     items: [
      //       {
      //         item_id: city, // id of the program
      //         item_name: 'EoE', // Name of the program (Ex - EoE)
      //         affiliation: '',
      //         coupon: '',
      //         discount: '',
      //         index: '',
      //         item_brand: isIeDone ? 'Yes' : 'No', //IE Status <Yes/No>
      //         item_category: ieLang, //IE Lang (User selected IE Language Ex- MR,EN,HI)
      //         item_category2: '',
      //         item_category3: '',
      //         item_category4: 'Sticky_CTA',
      //         item_category5: '',
      //         item_list_id: '',
      //         item_list_name: '',
      //         item_variant: '',
      //         location_id: cityName,
      //         price: '',
      //         quantity: '',
      //       },
      //     ],
      //   },
      // });
    }
  };

  return (
    isVisible && (
      <>
        {/* {!pathName?.endsWith('-toronto') && (
          <Box
            position="fixed"
            // boxShadow="-1px 7px 17px -1px rgba(0,0,0,0.75)"
            top={{ base: 'unset', md: '50%' }}
            bottom={{ base: '0', md: 'unset' }}
            zIndex="100"
            right={{ base: 'unset', md: '0', xl: '0' }}
            left={{ base: '50%', md: 'unset' }}
            width={{ base: '100%', md: 'auto' }}
            transform={{ base: 'translateX(-50%)', md: 'none' }}
            background="none"
            onClick={() => registerClick()}
          >
            <Link
              href={sectionContent[1]?.linkUrl || '#program-details-eoe'}
              _hover={{ textDecor: 'none' }}
              _active={{ textDecor: 'none' }}
              w="100%"
              _focus={{ textDecor: 'none' }}
            >
              <Flex
                mx="auto"
                // background={{ base: '#fff', md: 'none' }}
                alignItems="center"
                flexDirection={{ base: 'row', md: 'column' }}
                background={{ base: '#FFFFFF', md: 'none' }}
                width={{ base: '100%', md: '194px' }}
                py={{ base: '7px', md: '0' }}
                pl={{ base: '20px', md: '0' }}
                boxShadow={{
                  base: 'none',
                  md: '0px 9px 15px 0px rgba(0, 0, 0, 0.25)',
                }}
              >
                <Box
                  background={{ base: 'none', md: '#EFEFEF' }}
                  color="#F37021"
                  w={{ base: '45%', md: '100%' }}
                  py="12px"
                  borderRadius={{ base: '0', md: '5px 0 0' }}
                >
                  <Text
                    // bg="#fff"
                    color="#F37021"
                    fontFamily="FedraSansStd-book"
                    fontSize={{ base: '14px', md: '16px' }}
                    borderRadius={{
                      base: '5px 5px 0px 0px',
                      md: '5px 0 0px 0px',
                    }}
                    // w={{ base: '40%', sm: '45%', md: '100%' }}
                    m={{ base: '0' }}
                    mt={{ base: '0', md: '0' }}
                    textAlign="center"
                    bgColor="#EFEFEF"
                  >
                    <StructuredTextParser
                      str={render(
                        sectionContent[0].body?.value?.document?.children[0]
                      )}
                      region={region}
                      color="#F37021"
                      lang={lang}
                      mt="0px"
                      className="earlybird"
                    />
                  </Text>
                </Box>
                <NextLink
                  href={sectionContent[1]?.linkUrl || '#program-details-eoe'}
                  legacyBehavior
                  passHref
                >
                  <Link
                    region={region}
                    lang={lang}
                    bg="#FBAD2E"
                    fontFamily="FedraSansStd-medium"
                    color="#211637"
                    fontSize="14px"
                    // textTransform="uppercase"
                    _hover={{ bgColor: '#FBAD2E' }}
                    // px={{ base: '20px', md: '20px' }}
                    py="14px"
                    borderRadius={{ base: '5px', md: '0 0 0 5px' }}
                    display="flex"
                    flexDir="column"
                    border="0px"
                    mt={{ base: '0', md: '0' }}
                    mb={{ base: '0', md: '0' }}
                    textAlign="center"
                    m="0"
                    ml="auto"
                    mr={{ base: '15px', md: 'auto' }}
                    maxW={{ base: '155px', md: '194px' }}
                    w={{ base: '55%', md: '194px' }}
                  >
                    <StructuredTextParser
                      mt="0"
                      pt="0"
                      textAlign="center"
                      str={render(
                        sectionContent[0].body?.value?.document?.children[1]
                      )}
                    />
                  </Link>
                </NextLink>
              </Flex>
            </Link>

            <style global jsx>{`
              .earlybird p {
                text-align: center;
                font-size: 16px !important;
              }
              .earlybird p mark {
                font-family: FedraSansStd-medium;
                color: #f37021;
                background: transparent;
              }
              @media screen and (max-width: 768px) {
                .earlybird p {
                  font-size: 14px !important;
                }
              }
            `}</style>
          </Box>
        )} */}
        {/* {pathName?.endsWith('-toronto') && ( */}
          <Box
            position="fixed"
            // boxShadow="-1px 7px 17px -1px rgba(0,0,0,0.75)"
            top={{ base: 'unset', md: '50%' }}
            bottom={{ base: '0', md: 'unset' }}
            zIndex="100"
            right={{ base: 'unset', md: '20px', xl: '20px' }}
            left={{ base: '50%', md: 'unset' }}
            width={{ base: '100%', md: 'auto' }}
            transform={{ base: 'translateX(-50%)', md: 'none' }}
            background="none"
            onClick={() => registerClick()}
          >
            <Link
              href={sectionContent[1]?.linkUrl || '#program-details-eoe'}
              _hover={{ textDecor: 'none' }}
              _active={{ textDecor: 'none' }}
              w="100%"
              _focus={{ textDecor: 'none' }}
            >
              <Flex
                mx="auto"
                // background={{ base: '#fff', md: 'none' }}
                alignItems="center"
                flexDirection={{ base: 'row', md: 'column' }}
                background={{ base: '#211637', md: 'none' }}
                width={{ base: '100%', md: '274px' }}
                py={{ base: '7px', md: '0' }}
                px={{ base: '20px', md: '0' }}
                // boxShadow={{
                //   base: 'none',
                //   md: '0px 9px 15px 0px rgba(0, 0, 0, 0.25)',
                // }}
              >
                <Box
                  position={{ base: 'relative', md: 'unset' }}
                  top={{ base: '-15px', md: 'unset' }}
                  w="100%"
                >
                  {sectionContent[0].body?.value?.document?.children[0]?.children[0]?.value != '' && (
                    <Box
                      background={{
                        base: `url(${config.imgPath}/d/46272/1701337629-early_bird_ribbon_banner.png) no-repeat`,
                        md: `url(${config.imgPath}/d/46272/1701337629-early_bird_ribbon_banner.png) no-repeat`,
                      }}
                      backgroundSize={{ base: 'contain', md: 'cover' }}
                      color="#F37021"
                      w={{ base: '100%', md: '100%' }}
                      pt={{ base: '0', md: '2px' }}
                      pb={{ base: '25px', md: '18px' }}
                      borderRadius={{ base: '0', md: '5px 0 0' }}
                      backgroundPosition="bottom"
                    >
                      <Text
                        fontFamily="FedraSansStd-book"
                        fontSize={{ base: '14px', md: '16px' }}
                        borderRadius={{
                          base: '5px',
                          md: '5px',
                        }}
                        // w={{ base: '40%', sm: '45%', md: '100%' }}
                        m={{ base: '0' }}
                        mt={{ base: '0', md: '0' }}
                        textAlign="center"
                        // bgColor="#EFEFEF"
                      >
                        <StructuredTextParser
                          str={render(
                            sectionContent[0].body?.value?.document?.children[0]
                          )}
                          region={region}
                          color="#fff"
                          lang={lang}
                          mt="0px"
                          className="earlybird"
                        />
                      </Text>
                    </Box>
                  )}
                  <NextLink
                    href={sectionContent[1]?.linkUrl || '#program-details-eoe'}
                    legacyBehavior
                    passHref
                  >
                    <Link
                      region={region}
                      lang={lang}
                      bg="#FBAD2E"
                      fontFamily="FedraSansStd-medium"
                      color="#211637"
                      fontSize="14px"
                      // textTransform="uppercase"
                      _hover={{ bgColor: '#FBAD2E' }}
                      // px={{ base: '20px', md: '20px' }}
                      py="14px"
                      borderRadius={{ base: '5px', md: '5px' }}
                      display="flex"
                      flexDir="column"
                      border="0px"
                      mt={{ base: '0', md: '0' }}
                      mb={{ base: '0', md: '0' }}
                      textAlign="center"
                      m="0"
                      ml="auto"
                      mr={{ base: '15px', md: 'auto' }}
                      maxW={{ base: '100%', md: '274px' }}
                      w={{ base: '100%', md: '274px' }}
                    >
                      <StructuredTextParser
                        mt="0"
                        pt="0"
                        textAlign="center"
                        str={render(
                          sectionContent[0].body?.value?.document?.children[1]
                        )}
                      />
                    </Link>
                  </NextLink>
                </Box>
              </Flex>
            </Link>

            <style global jsx>{`
              .earlybird p {
                text-align: center;
                font-size: 16px !important;
              }
              .earlybird p mark {
                font-family: FedraSansStd-medium;
                color: #fff;
                background: transparent;
              }
              @media screen and (max-width: 768px) {
                .earlybird p {
                  font-size: 14px !important;
                }
              }
            `}</style>
          </Box>
        {/* )} */}
      </>
    )
  );
};

export default RegisterStickyButton;
